'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactDnd = require('react-dnd');

var _reactDndHtml5Backend = require('react-dnd-html5-backend');

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _elementRegistry = require('../../../../common/elements/elementRegistry');

var elementFactory = _interopRequireWildcard(_elementRegistry);

var _elementActions = require('../../../element/elementActions');

var _undoRedoActions = require('../../../utils/undoRedo/undoRedoActions');

var _elementConstants = require('../../../../common/elements/elementConstants');

var _draggingActions = require('../../../reducers/draggingActions');

var _popupActions = require('../../../components/popupPanel/popupActions');

var _analytics = require('../../../analytics');

var _Tool = require('../Tool');

var _Tool2 = _interopRequireDefault(_Tool);

var _Icon = require('../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _PopupPanel = require('../../../components/popupPanel/PopupPanel');

var _PopupPanel2 = _interopRequireDefault(_PopupPanel);

var _buildNewElementDragOffsetsMap = require('./buildNewElementDragOffsetsMap');

var _buildNewElementDragOffsetsMap2 = _interopRequireDefault(_buildNewElementDragOffsetsMap);

require('./ElementTool.scss');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        startDragging: function startDragging() {
            return dispatch((0, _draggingActions.dragStart)());
        },
        endDragging: function endDragging() {
            return dispatch((0, _draggingActions.dragEnd)());
        },
        dispatchEndMoveOperation: function dispatchEndMoveOperation() {
            return dispatch((0, _undoRedoActions.endOperation)('move'));
        },
        onDrop: function onDrop(location, transactionId) {
            return dispatch((0, _elementActions.createAndSelectElement)({
                elementType: ownProps.elementType,
                location: location,
                currentBoardId: ownProps.currentBoardId,
                transactionId: transactionId
            }));
        },
        showTooltip: function showTooltip() {
            (0, _analytics.analyticsEvent)('clicked-toolbar-tool');
            dispatch((0, _popupActions.openPopup)('tooltip-' + ownProps.elementType));
        }
    };
};

var toolSource = {
    // Returns the data describing the dragged tool
    beginDrag: function beginDrag(_ref) {
        var elementType = _ref.elementType,
            startDragging = _ref.startDragging,
            gridSize = _ref.gridSize;

        startDragging();
        var element = elementFactory.createElementObject({ id: 'previewElement', elementType: elementType, location: {} });
        var elementId = element.id;
        element = Immutable.fromJS(element);
        var offsetsMap = (0, _buildNewElementDragOffsetsMap2.default)({ element: element, gridSize: gridSize });
        return {
            element: element,
            draggedElementIds: [elementId],
            draggedElements: [element],
            offsetsMap: offsetsMap,
            hoveredItems: {},
            hoveredTypes: {},
            isCreate: true
        };
    },


    // Handles when the tool is dropped
    endDrag: function endDrag(props, monitor, component) {
        props.endDragging();
        var operationTransactionId = props.dispatchEndMoveOperation();

        // Doing nothing if it was not dropped onto a compatible target
        if (!monitor.didDrop()) return;

        var dropResult = monitor.getDropResult();
        // Only drop if a location is returned by the drop target
        if (dropResult.location) {
            /* WORKAROUND:
             * This is a synthetic event that we're creating to ensure that the React "SelectEventPlugin" works with
             * the drag and drop (react-dnd) and text editing (draft-js) libraries.
             *
             * React adds an "onSelect" event to content editable elements.  This is not standard in HTML, but the
             * Draft JS text editor relies on this event to track the position of the cursor or the selection state.
             *
             * The SelectEventPlugin prevents the onSelect event whenever a drag occurs (in case the user is selecting,
             * so it has a flag variable "mouseDown" that gets set to true on the mouseDown event and false on the
             * mouseUp event.
             * We're using the HTML5 backend of the React DnD library, so it uses the standard HTML5 drag and drop
             * events.  With HTML5 drag and drop the mouseMove and mouseUp events are not fired once a drag starts.
             * Thus the React "SelectEventPlugin" receives a "mouseDown" event, but never receives a mouse up event
             * when the drop finishes.
             * As such the SelectEventPlugin doesn't set mouseDown flag to false, and the onSelect event will not fire
             * until a future mouse click forces the mouseDown flag back to false.
             *
             * Because we immediately set the element into its editing state when an element tool drop occurs, the
             * onSelect event is not being fired.
             *
             * By firing this synthetic event we force the SelectEventPlugin to set its mouseDown flag to false, and as
             * such the onSelect events will now fire when entering the editing mode after being dropped onto the
             * canvas.
             */
            var event = new MouseEvent('mouseup', { bubbles: true });
            document.body.dispatchEvent(event);

            var transactionId = dropResult.transactionId || operationTransactionId;
            props.onDrop(dropResult.location, transactionId);
        }
    }
};

var dragCollect = function dragCollect(connector, monitor) {
    return {
        // Call inside render() to let React handle the drag event
        connectDragSource: connector.dragSource(),
        connectDragPreview: connector.dragPreview(),
        // Get current drag state from the monitor
        isDragging: monitor.isDragging()
    };
};

// connectDragSource and isDragging are added by the collect function
/* eslint-disable react/prefer-stateless-function */
var ElementTool = (_dec = (0, _reactRedux.connect)(null, mapDispatchToProps), _dec2 = (0, _reactDnd.DragSource)(_elementConstants.ELEMENT_DND_TYPE, toolSource, dragCollect), _dec(_class = _dec2(_class = function (_React$Component) {
    _inherits(ElementTool, _React$Component);

    function ElementTool() {
        _classCallCheck(this, ElementTool);

        return _possibleConstructorReturn(this, (ElementTool.__proto__ || Object.getPrototypeOf(ElementTool)).apply(this, arguments));
    }

    _createClass(ElementTool, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var connectDragPreview = this.props.connectDragPreview;

            if (connectDragPreview) {
                connectDragPreview((0, _reactDndHtml5Backend.getEmptyImage)());
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                connectDragSource = _props.connectDragSource,
                elementType = _props.elementType,
                showTooltip = _props.showTooltip;


            return connectDragSource(_react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _Tool2.default,
                    _extends({}, this.props, {
                        className: 'ElementTool',
                        isDraggable: true,
                        handleClick: showTooltip,
                        tooltip: elementFactory.getElementTooltip(elementType) }),
                    _react2.default.createElement(_Icon2.default, { name: 'element-' + elementType.toLowerCase() }),
                    _react2.default.createElement(
                        _PopupPanel2.default,
                        { className: 'tooltip',
                            popupId: 'tooltip-' + elementType,
                            arrowDir: 'left',
                            duration: 4000,
                            fadeIn: true },
                        _react2.default.createElement(
                            'span',
                            null,
                            'Drag me'
                        )
                    )
                )
            ));
        }
    }]);

    return ElementTool;
}(_react2.default.Component)) || _class) || _class);
exports.default = ElementTool;


ElementTool.propTypes = {
    name: _propTypes2.default.string.isRequired,
    elementType: _propTypes2.default.string.isRequired,
    currentBoardId: _propTypes2.default.string.isRequired,
    connectDragSource: _propTypes2.default.func,
    connectDragPreview: _propTypes2.default.func,
    isDragging: _propTypes2.default.bool,
    showTooltip: _propTypes2.default.func
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/elementTools/ElementTool.js
// module id = 2219
// module chunks = 0